<div class="d-inline-flex">
  <ncp-button
    #addProblemButton
    [options]="btnPDOptions()"
  >
    @if (!btnPDOptions().isLoading) {
      <img
        [ngSrc]="assets.healthIcons.svg.outline.conditions.chills_fever.src"
        width="18"
        height="18"
        alt="Add Problem/Diagnosis"
        class="healthIcon"
      />
    }
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="problem_diagnosis_form"
      name="problem_diagnosis_form"
      [formGroup]="form"
      #pdFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown #problemDesc [(options)]="problemDescDDOptions" />
      <ncp-date #problemDate [(options)]="onSetDateOptions" />
      <ng-template #problemTemplate let-value>
        <div class="d-flex flex-row">
          <div class="col-6 text-wrap">{{ value.code }}</div>
          <div class="col-6 text-wrap">{{ value.description }}</div>
        </div>
      </ng-template>
    </form>
  </ncp-modal>
</div>
